// extracted by mini-css-extract-plugin
export const root = "container-module--root--ACgVt";